import { render, staticRenderFns } from "./ChipLink.vue?vue&type=template&id=eb3189ac&scoped=true"
import script from "./ChipLink.vue?vue&type=script&lang=js"
export * from "./ChipLink.vue?vue&type=script&lang=js"
import style0 from "./ChipLink.vue?vue&type=style&index=0&id=eb3189ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3189ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VHover,VIcon})
